// STAPLED SECURITIES
export const stapledSecDocs = [
  {
    id: 'stapled_security_exception',
    label: 'Stapled Security Exception'
  }
];
